
import { mapState, mapGetters } from "vuex";
import { mdiCheck, mdiImage } from "@mdi/js";
import InteractiveGallery from "@/components/profile/interactive-gallery.vue";

export default {
  components: {
    InteractiveGallery,
  },

  inject: {
    _imgAlt: {
      default: "",
    },
    _h1: {
      default: "",
    },
  },

  props: {
    profile: {
      type: Object,
    },

    hasCheckbox: {
      type: Boolean,
    },

    selectedAllPhoto: {
      type: Boolean,
      default: false,
    },

    mobileGalleryTab: {
      type: String,
    },
  },

  data() {
    return {
      blocks: [],
      mdiCheck,
      mdiImage,
      selectedPhoto: [],

      nothing: "",
      showModal: false,
      slug: this.$route.params.slug,

      swiperOptions: {
        slidesPerView: 3.1,
        spaceBetween: 8,
      },

      profileGalleryMode: "slider", // "grid", "slider"
    };
  },

  computed: {
    ...mapState(["profiles"]),

    ...mapGetters({
      discreetMode: "getDiscreetStatus",
      filtersList: "profiles/getFiltersList",
    }),

    isMobile() {
      return this.$store.state.global.mobile;
    },

    nationality() {
      return this.filtersList.nationality[
        +this.profile.myDetails[0].nationality
      ];
    },

    city() {
      return this.profile.location[0].baseCity;
    },

    currentGallery() {
      if (this.mobileGalleryTab === "profile-gallery") {
        return this.profile.gallerySecond;
      }

      if (this.mobileGalleryTab === "profile-selfie") {
        return this.profile.galleryFirst;
      }

      return [];
    },
  },

  watch: {
    selectedAllPhoto() {
      if (this.selectedAllPhoto) {
        this.selectedPhoto = [];

        for (let i = 0; i < this.profile.gallery.length; i++) {
          this.selectedPhoto.push(this.profile.gallery[i].src);
        }

        this.$emit("changePhoto", this.selectedPhoto);
      } else {
        this.selectedPhoto = [];
        this.$emit("changePhoto", this.selectedPhoto);
      }
    },

    showModal() {
      if (this.showModal) {
        document.documentElement.style.overflow = "hidden";
      } else {
        document.documentElement.style.overflow = "auto";
      }
    },
  },

  mounted() {
    this.$on("open-gallery", () => {
      this.showModal = true;
    });
  },

  methods: {
    reachBeginning() {
      this.$refs.cont.classList.remove("end");
    },

    reachEnd() {
      this.$refs.cont.classList.add("end");
    },

    selectPhoto() {
      this.$emit("changePhoto", this.selectedPhoto);
    },

    imgAlt(index) {
      return `${this._imgAlt} - Photo ${index + 1} of ${
        this.currentGallery.length
      }`;
    },

    imgTitle(index) {
      return `${this._h1} - Photo ${index + 1} of ${
        this.currentGallery.length
      }`;
    },

    showGridMode() {
      this.profileGalleryMode = "grid";
      this.$nextTick(() => {
        this.$refs.mobileInteractiveGallery.calculateCellSize();
      });
    },
  },
};
